import { FieldValues, SetValueConfig, UseFormSetValue } from 'react-hook-form';
import DocumentFormFieldNames from '@lib/enums/fieldNames/documentFormFieldNames';

type CategoryData = {
  id: string;
  name: string;
  color?: string | null;
  allowDownload?: boolean | null;
  allowPrint?: boolean | null;
};

// Writes a category picked outside the Select (inline "Create new", AI
// suggestion) into the form. setValue doesn't emit a `change` event, so
// getCategoryFields' fieldChangeCallBack never prefills the permission
// checkboxes — mirror it here. The option also carries the category's
// permission defaults, which the "custom permissions" notice compares against.
export default function setCategoryWithPermissions(
  setValue: UseFormSetValue<FieldValues>,
  category: CategoryData,
  options?: SetValueConfig,
) {
  setValue(
    DocumentFormFieldNames.Category,
    {
      value: category.id,
      label: category.name,
      color: category.color,
      allowDownload: category.allowDownload,
      allowPrint: category.allowPrint,
    },
    options,
  );
  setValue(DocumentFormFieldNames.AllowDownload, !!category.allowDownload, {
    shouldDirty: true,
  });
  setValue(DocumentFormFieldNames.AllowPrint, !!category.allowPrint, {
    shouldDirty: true,
  });
}
